import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/availability');

class AvailabilityApiAgency {
	static get (userId: number) {
		return client.get<IAvailabilityModel>(userId.toString());
	}
}

export default AvailabilityApiAgency;
